import { Cell } from 'common/src/designSystem/components/table/cell';
import { VolunteerRegistrationFragment } from 'common/src/generated/types';
import { getStateBadgeColorIcon } from 'common/src/vo/email';
import * as React from 'react';
import { BadgesPlus } from '../../../components/badgesPlus/badgesPlus';
import { useHeavent } from '../../../hooks/useHeavent';

interface IVolunteerRegistrationCampaignsStatesCellProps {
    volunteerRegistration: VolunteerRegistrationFragment;
}

export const VolunteerRegistrationCampaignsStatesCell = (
    props: IVolunteerRegistrationCampaignsStatesCellProps
) => {
    const { translate } = useHeavent();
    const badges = React.useMemo(
        () =>
            (props.volunteerRegistration.userInfo.emails ?? []).map((email) => {
                const { color, leftIcon } = getStateBadgeColorIcon(email.state);

                return {
                    id: email.id,
                    color,
                    icon: leftIcon,
                    text: `${email.campaign?.name ?? ''} - ${translate(email.state)}`
                };
            }),
        [props.volunteerRegistration]
    );

    return (
        <Cell>
            <BadgesPlus badges={badges} />
        </Cell>
    );
};
